import { render, staticRenderFns } from "./ProductAiImages.vue?vue&type=template&id=654f8768&scoped=true"
import script from "./ProductAiImages.vue?vue&type=script&lang=js"
export * from "./ProductAiImages.vue?vue&type=script&lang=js"
import style0 from "./ProductAiImages.vue?vue&type=style&index=0&id=654f8768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654f8768",
  null
  
)

export default component.exports